import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  OverlayComponent,
  TableCellDirective,
  TableColumnDirective,
  TableComponent,
  TableHeaderDirective,
} from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { LastOrderedProductQuantity } from '@libs/shop/models';
import { LuxonDatePipe } from '@libs/shared/ui';

@Component({
  selector: 'ui-order-quantities',
  templateUrl: './order-quantities.component.html',
  styleUrls: ['order-quantities.component.scss'],
  imports: [
    OverlayComponent,
    TableComponent,
    TableCellDirective,
    TableColumnDirective,
    TableHeaderDirective,
    IconComponent,
    LuxonDatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [OverlayContainer],
})
export class OrderQuantitiesComponent implements OnInit {
  @Input() public orderQuantities!: LastOrderedProductQuantity[];
  public formattedOrderQuantities: string[] = [];

  public ngOnInit(): void {
    this.formattedOrderQuantities = new Array<string>(4).fill('-');

    for (let i: number = 0; i < 4; i++) {
      if (this.orderQuantities[i]) {
        this.formattedOrderQuantities[i] = this.orderQuantities[i].quantity.toString();
      }
    }

    this.formattedOrderQuantities = this.formattedOrderQuantities.reverse();
  }
}
